import { Collection } from 'modules/core/lib/mobx-rest'

import PublicHoliday from 'modules/locations/store/models/PublicHoliday'

class PublicHolidays extends Collection<PublicHoliday> {
  get cacheKey(): string {
    return 'publicHolidays'
  }

  model() {
    return PublicHoliday
  }
}

const singleton: PublicHolidays = new PublicHolidays()

export default singleton
